module.exports = __webpack_public_path__ + "static/media/editenable.259f5b82.svg";